import { ActionLink } from 'app/_shared'
import clsx from 'clsx'

import styles from './SubTabSelector.module.scss'

export default ({ subTabs, activeSubTab, setActiveSubTab }) => {
  return (
    <div className={styles.selector}>
      {subTabs.map(t => (
        <ActionLink
          key={t}
          className={clsx(styles.item, activeSubTab === t && styles.active)}
          onClick={() => setActiveSubTab(t)}
        >
          {t}
        </ActionLink>
      ))}
    </div>
  )
}
